<template>
  <page>
    <template slot="content">
    <help-content :title="'歩数計測しているデバイスを確認する方法'">
      <template slot="content">
        <div class="text">
          ホーム画面の右上に歩数計測しているデバイス名が表示されています。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H28.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help28.vue